var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { Grid } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { OverlayBox } from "./Overlay";
var StyledOutput = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5px;\n  display: table-cell;\n  min-height: 100px;\n  overflow: auto;\n  white-space: pre-wrap;\n"], ["\n  padding: 5px;\n  display: table-cell;\n  min-height: 100px;\n  overflow: auto;\n  white-space: pre-wrap;\n"])));
var WithBrowserIncompatibilityOverlay = function (_a) {
  var children = _a.children;
  var t = useTranslation()[0];
  var ieOrEdge = window.StyleMedia && window.navigator.userAgent.indexOf("Edge") !== -1;
  return React.createElement("div", {
    style: {
      position: "relative",
      width: "inherit"
    }
  }, ieOrEdge && React.createElement(OverlayBox, null, React.createElement(StyledOutput, null, t("browserNotSupported"), React.createElement("ul", null, React.createElement("li", null, "Apple Safari"), React.createElement("li", null, "Google Chrome"), React.createElement("li", null, "Mozilla Firefox")))), children);
};
export default WithBrowserIncompatibilityOverlay;
var templateObject_1;